var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.25,
    height: 23,
    viewBox: "0 0 17.25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M19.985,4.932,15.193.14A.479.479,0,0,0,14.854,0H4.792A1.919,1.919,0,0,0,2.875,1.917V21.083A1.919,1.919,0,0,0,4.792,23H18.208a1.919,1.919,0,0,0,1.917-1.917V5.271A.479.479,0,0,0,19.985,4.932Zm-4.651-3.3,3.156,3.156h-2.2a.96.96,0,0,1-.958-.958Zm3.833,19.447a.96.96,0,0,1-.958.958H4.792a.96.96,0,0,1-.958-.958V1.917A.96.96,0,0,1,4.792.958h9.583V3.833A1.919,1.919,0,0,0,16.292,5.75h2.875Z",
    transform: "translate(-2.875)",
    fill: "#e10b0b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M13.943,14.067a13.888,13.888,0,0,1-1.146-.989c-.365-.365-.69-.719-.973-1.056a10.728,10.728,0,0,0,.634-2.439c0-1.591-.575-1.917-1.437-1.917-.656,0-1.437.341-1.437,1.963a4.6,4.6,0,0,0,1.168,2.592c-.19.58-.413,1.248-.664,2-.121.362-.252.7-.39,1.007-.113.05-.222.1-.328.154-.381.19-.743.362-1.078.521-1.53.724-2.541,1.2-2.541,2.15,0,.687.746,1.112,1.438,1.112.891,0,2.236-1.19,3.219-3.195a19.064,19.064,0,0,1,3.289-.887,5.5,5.5,0,0,0,2.117,1.207c1.188,0,1.438-.687,1.438-1.263,0-1.133-1.294-1.133-1.917-1.133A11.35,11.35,0,0,0,13.943,14.067ZM7.188,18.208a.757.757,0,0,1-.479-.154c0-.34,1.013-.82,1.993-1.284l.19-.089C8.171,17.725,7.459,18.208,7.188,18.208Zm3.354-8.579c0-1,.312-1,.479-1,.339,0,.479,0,.479.958a7.683,7.683,0,0,1-.381,1.5A2.944,2.944,0,0,1,10.542,9.629Zm.367,5.15q.045-.125.087-.253c.178-.533.338-1.013.481-1.444q.3.328.643.673c.09.09.313.292.609.545C12.138,14.429,11.51,14.589,10.909,14.779Zm5.383.249c0,.215,0,.3-.445.307a3.532,3.532,0,0,1-.8-.46c.135-.015.235-.022.291-.022C16.041,14.854,16.242,14.923,16.292,15.029Z",
    transform: "translate(-2.875)",
    fill: "#e10b0b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7049295676fe532f761cf719640a0388.svg";
export { ForwardRef as ReactComponent };